import React, { ReactNode } from 'react';
import './DonationSummary.scss';

export type DonationSummaryItemProps = {
  label: ReactNode;
  children: ReactNode;
};

export class DonationSummaryItem extends React.PureComponent<
  DonationSummaryItemProps
> {
  render() {
    const { label, children } = this.props;
    return (
      <div>
        <dt className={`jg-text--small jg-space-mbsm`}>{label}</dt>
        <dd className={`jg-space-mbsm jg-text--light`}>{children}</dd>
      </div>
    );
  }
}

export default DonationSummaryItem;
